import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from '../pages/Homepage';
import Login from '../pages/Login';
import SignUp from '../pages/Signup';
import Courses from '../pages/Courses';
import Pricings from '../pages/Pricings';
import PaymentPage from '../pages/PaymentPage';
import CourseDetails from '../pages/CourseDetails';
import CourseCompletion from '../pages/CourseCompletion';
// import SchoolSignUp from '../pages/SchoolSignup';
import VerifyPage from '../pages/VerifyPage';
import PublicRoute from './PublicRoute'; // Adjust import based on your structure
import PrivateRoute from './PrivateRoute'; // Adjust import based on your structure
import ForgotPassword from '../pages/ForgetPassword';
import StudentDashboard from '../pages/StudentDashboard';
import ProfilePage from '../pages/ProfilePage';
import Subscription from '../pages/SubscriptionAndPayment';
import ResetPassword from '../pages/ResetPassword';
import NotFound from '../pages/NotFound';
import Coding from '../pages/Coding';
import EmailVerifyPage from '../pages/EmailVerifyPage';
import CancelSubscription from '../pages/CancelSubscription';
import OverviewPage from '../pages/OverviewPage';
import ContactUs from '../pages/FooterPages/ContactUs';
import AffiliatePage from '../pages/FooterPages/AffiliatePage';
import TermOfServicePage from '../pages/FooterPages/TermOfServicePage';
import CookiePolicyPage from '../pages/FooterPages/CookiePolicyPage';
import FaqPage from '../pages/FooterPages/FAQPage';
import PrivacyPage from '../pages/FooterPages/PrivacyPage';
import AffiliateTermsPage from '../pages/FooterPages/AffiliateTermsPage';
import AffiliateForm from '../pages/FooterPages/AffiliateForm';
import BlogList from '../pages/BlogList';
import BlogDetails from '../pages/BlogDetails';
import BlogCategory from '../pages/BlogCategory';

const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/courses" element={<Courses />} />
      <Route path="/courses/:courseId" element={<CourseDetails />} />
      <Route path="/" element={<PublicRoute />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/verify/:userId/:username" element={<VerifyPage />} />
        <Route path="/forget-password" element={<ForgotPassword />} />

        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/pricing/annually" element={<Pricings plan="annual" />} />
        <Route
          path="/pricing/twoyears"
          element={<Pricings plan="two-year" />}
        />
        <Route path="/affiliate" element={<AffiliatePage />} />
        <Route path="/affiliate-form" element={<AffiliateForm />} />
        <Route path="/affiliate-terms" element={<AffiliateTermsPage />} />
        <Route path="/terms" element={<TermOfServicePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/page/:pageNumber" element={<BlogList />} />
        <Route path="/blog/category/:categorySlug" element={<BlogCategory />} />
        <Route
          path="/blog/category/:categorySlug/page/:pageNumber"
          element={<BlogCategory />}
        />
        <Route path="/blog/:slug" element={<BlogDetails />} />
        <Route path="/payment" element={<PaymentPage />} />
      </Route>
      {/* Private Routes */}
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/email-verify/:userId/" element={<EmailVerifyPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route
          path="/courses/completion/:courseId"
          element={<CourseCompletion />}
        />
        <Route path="/courses/coding" element={<Coding />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile/subscription" element={<Subscription />} />

        <Route
          path="/profile/cancel-subscription"
          element={<CancelSubscription />}
        />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/student-dashboard" element={<StudentDashboard />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;
